/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Grade_CreateInputs */

const vi_tea_grade_create = /** @type {(inputs: Tea_Grade_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm phân loại`)
};

/**

* @param {Tea_Grade_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_create = /** @type {((inputs?: Tea_Grade_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_create(inputs)
});